import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventemitterService {

  private subjectUpdateUser = new Subject<any>();

  constructor() { }

  setUpdatedUserData(data: any) {
    this.subjectUpdateUser.next(data);
  }

  getUpdatedUserData() {
    return this.subjectUpdateUser.asObservable();
  }

}
